import { trackTransactionDetailsAmplitudeEvent } from '@/modules/transaction/helpers/track-amplitude-event';

export function trackWithdrawModalLoad() {
  trackTransactionDetailsAmplitudeEvent({
    event_type: 'Load',
    event_name: 'view'
  });
}

export function trackCancelWithdrawClick() {
  trackTransactionDetailsAmplitudeEvent({
    event_type: 'Click',
    event_name: 'cancel_transfer'
  });
}

export function trackConfirmCancelWithdrawClick() {
  trackTransactionDetailsAmplitudeEvent({
    event_type: 'Click',
    event_name: 'confirm_transfer'
  });
}

export function trackRefuseCancelWithdrawClick() {
  trackTransactionDetailsAmplitudeEvent({
    event_type: 'Click',
    event_name: 'refuse_transfer'
  });
}
